var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEllipsisCircle = function SvgEllipsisCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.875a4.875 4.875 0 1 0 0-9.75 4.875 4.875 0 0 0 0 9.75M7 1a6 6 0 1 1 0 12A6 6 0 0 1 7 1m.75 6a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m1.5-.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5M5.5 7A.75.75 0 1 1 4 7a.75.75 0 0 1 1.5 0"
  })));
};
export default SvgEllipsisCircle;